import auth from './auth'
import common from './common'
import payment from './payment'
import applicant from './applicant'

const api = {
  auth,
  common,
  payment,
  applicant
}

export default api
